import React from "react";
import { SectionCard, LabeledSelect } from "../forms/formPrimitives";
export const zeigtPartnerBank = (kooperation: boolean, wert: string) =>
  kooperation || wert === "true";
/** Derselbe Baustein in Anlage und Akte; ausgeblendete Bankwerte werden nie geleert. */
export function PartnerAbrechnung({
  kooperation,
  wert,
  onChange,
  onPortfolio,
}: {
  kooperation: boolean;
  wert: string;
  onChange: (wert: string) => void;
  onPortfolio?: () => void;
}) {
  return (
    <SectionCard title="Abrechnung (Courtage)">
      {kooperation ? (
        <p>Die Abrechnung erfolgt über diesen Kooperationspartner.</p>
      ) : (
        <LabeledSelect
          label="Rechnet der Produktpartner direkt mit Courté ab?"
          name="partnerAbrechnungDirekt"
          value={wert}
          onChange={onChange}
          options={[
            { value: "true", label: "Ja" },
            { value: "false", label: "Nein" },
          ]}
          placeholder="Bitte auswählen"
        />
      )}
      {zeigtPartnerBank(kooperation, wert) ? (
        onPortfolio ? (
          <button type="button" className="btn" onClick={onPortfolio}>
            Zum Produktportfolio
          </button>
        ) : (
          <p>
            Das Produktportfolio kann nach dem Anlegen in der Akte gepflegt
            werden.
          </p>
        )
      ) : (
        <p>
          Produkte über Kooperationspartner erscheinen im Produktportfolio
          lesend. Bestehende Bankverbindungen bleiben gespeichert.
        </p>
      )}
    </SectionCard>
  );
}
